import axios from "axios";
import { API_URL } from "./config";
import { getAuthItem } from "../utils/indexDB";
// Base URL for your API
//localhost for now later fetch it from .env
// const API_URL = "http://localhost:8000/api";

/**
 * Generic API call function
 * @param {string} endpoint - The API endpoint (e.g., '/data')
 * @param {string} method - The HTTP method ('GET', 'POST', 'PUT', 'DELETE', etc.)
 * @param {object} [data] - The data to be sent with the request (for POST/PUT)
 * @param {object} [params] - URL parameters for GET requests
 * @returns {Promise} - Resolves with the response data or rejects with an error
 */

let cachedAccessToken = null;

const getCachedAccessToken = async () => {
  if (!cachedAccessToken) {
    cachedAccessToken = await getAuthItem("accessToken");
  }
  return cachedAccessToken;
};

const apiCall = async ({
  endpoint,
  method = "GET",
  data = null,
  params = {},
  headers = {},
}) => {
  const accessToken = await getCachedAccessToken();
  const defaultHeaders = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json", // Default content type
  };

  const config = {
    method,
    headers: { ...defaultHeaders, ...headers },
    url: `${API_URL}/api${endpoint}`,
    data,
    params,
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Check if there is a response from the server
      if (error.response) {
        throw error.response;
      } else {
        throw error.message;
      }
    } else {
      throw error;
    }
  }
};

export default apiCall;
